export class TypeCPVClass {

	public classPrincipale: string;

	constructor() {
		this.classPrincipale = '';
	}
}
